import { render, staticRenderFns } from "./delivery-json-email.vue?vue&type=template&id=57db7cb4"
import script from "./delivery-json-email.vue?vue&type=script&lang=js"
export * from "./delivery-json-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports